import { Season, TournamentStatus, Player, Team, NewsArticle, BadgeType, Tournament } from '../types';
import { INITIAL_ELO } from '../constants';

import rosterData from './seed/roster.json';
import teamsData from './seed/teams.json';
import manualBadgesData from './seed/manual_badges.json';
import tournamentsData from './seed/tournaments.json';
import doublesTournamentsData from './seed/doubles_tournaments.json';
import newsData from './seed/news.json';
import doublesNewsData from './seed/doubles_news.json';

const INITIAL_STATS = {
  wins: 0,
  losses: 0,
  championships: 0,
  pointsWon: 0,
  pointsLost: 0,
  matchesPlayed: 0,
  majorTitles: 0,
  minorTitles: 0
};

const INITIAL_ADVANCED_STATS = {
  clutchWins: 0,
  clutchTotal: 0,
  nemesisId: null,
  nemesisWinPct: 0,
  longestStreak: 0,
  currentStreak: 0,
  peakElo: INITIAL_ELO,
  form: [],
  servicePointsWon: 0,
  servicePointsTotal: 0,
  returnPointsWon: 0,
  returnPointsTotal: 0,
  aces: 0,
  winners: 0,
  errors: 0,
  totalPointsPlayed: 0,
  deuceWins: 0,
  deuceTotal: 0,
  gamePointsConverted: 0,
  gamePointOpportunities: 0,
  cleanSheets: 0
};

export const MANUAL_BADGES: Record<string, Record<string, number>> = manualBadgesData;

export const ROSTER: Player[] = rosterData.map(p => ({
  ...p,
  elo: INITIAL_ELO,
  stats: { ...INITIAL_STATS },
  advancedStats: { ...INITIAL_ADVANCED_STATS },
  badges: (MANUAL_BADGES[p.id] as Record<BadgeType, number>) || {}
}));

export const INITIAL_TEAMS: Team[] = teamsData.map(t => ({
    ...t,
    elo: INITIAL_ELO,
    stats: { ...INITIAL_STATS },
    advancedStats: { ...INITIAL_ADVANCED_STATS },
    badges: {}
}));

export const PAST_TOURNAMENTS: Tournament[] = tournamentsData as Tournament[];
export const PAST_DOUBLES_TOURNAMENTS: Tournament[] = doublesTournamentsData as Tournament[];

export const INITIAL_NEWS: NewsArticle[] = newsData as NewsArticle[];
export const INITIAL_DOUBLES_NEWS: NewsArticle[] = doublesNewsData as NewsArticle[];